import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import {
	useAddTrendResearchPersonalSettingsMutation,
	useLazyFetchTrendResearchPersonalSettingsQuery
} from '@features/trend-research/api/onboardingApi';

import { clearCosting } from '@store/actions/CostingAction';
import {
	clearFilterResponse,
	clearGlobalFilter,
	removeItemFromGlobalFilter,
	storeInitialItemInGlobalFilter,
	storeItemInGlobalFilter
} from '@store/actions/FilterAction';
import { clearPhotography } from '@store/actions/PhotographyAction';
import { clearSampleRequest } from '@store/actions/SampleAction';
import { clearTeamFilter } from '@store/actions/TeamMemberAction';
import { setFilters } from '@store/common/action';
import { initialFilters } from '@store/common/reducer';

import ApiClient from '@lib/apiClient';

export const TopNavLink = ({ to, classes, title, onClick, children }) => {
	const dispatch = useDispatch();
	const [addTrendResearchPersonalSettings] = useAddTrendResearchPersonalSettingsMutation();
	const filterData = useSelector((store) => store.filterFieldStore);
	const [fetchTrendResearchPersonalSettings, { data: personalSettings }] =
		useLazyFetchTrendResearchPersonalSettingsQuery();
	const location = useLocation();

	useEffect(() => {
		if (location.pathname === '/trends') {
			fetchTrendResearchPersonalSettings({
				key: 'TREND_FILTER'
			});
		}
	}, [location]);

	useEffect(() => {
		if (location.pathname === '/trends' && personalSettings?.value) {
			const settings = JSON.parse(personalSettings?.value);
			if (settings) {
				dispatch(storeInitialItemInGlobalFilter(settings));
			}
		}
	}, [personalSettings, location]);

	const handleTab = (status) => {
		let data = {};
		data = {
			key: status,
			name: 'status',
			value: status,
			subStatus: null,
			type: 'SELECT'
		};
		dispatch(storeItemInGlobalFilter(data));
	};

	const clearGlobalState = () => {
		if (location.pathname === '/trends') {
			addTrendResearchPersonalSettings({
				requestBody: {
					key: 'TREND_FILTER',
					value: JSON.stringify({ ...filterData, trendResearchSearch: [] })
				}
			});
		}
		if (to.startsWith('/trends')) {
			ApiClient.POST('mixpanelAddEvent', {}, 'TRENDS_MENU_ON_CLICK');
		}

		if (to.startsWith('/orders/my-orders')) {
			dispatch(removeItemFromGlobalFilter({ name: 'filterCategory' }));
		} else {
			dispatch(clearGlobalFilter());
			if (to.startsWith('/sample/all')) {
				handleTab('PENDING');
			}
		}

		dispatch(setFilters(initialFilters));
		dispatch(clearFilterResponse());
		dispatch(clearSampleRequest());
		dispatch(clearPhotography());
		dispatch(clearCosting());
		dispatch(clearTeamFilter());
		onClick(to);
	};

	return (
		<li className={classes}>
			{to === '#' ? (
				<span>{title}</span>
			) : (
				<Link to={to} onClick={() => clearGlobalState()}>
					{title}
				</Link>
			)}
			{children}
		</li>
	);
};
